var _circle, _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#45C777"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_374_6791)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24L9.13085 19.8935C8.43171 18.6882 8.06495 17.3232 8.06877 15.9277C8.06877 11.5551 11.6447 7.99997 16.0344 7.99997C18.1662 7.99997 20.1681 8.82506 21.6695 10.3232C23.1748 11.8213 24.0038 13.8137 24 15.9315C24 20.3042 20.4241 23.8593 16.0306 23.8593H16.0267C14.6934 23.8593 13.383 23.5247 12.2178 22.8935L8 24ZM12.4202 21.46L12.6609 21.6045C13.6772 22.2053 14.8424 22.5209 16.0306 22.5247H16.0344C19.6829 22.5247 22.6552 19.5703 22.6552 15.9353C22.6552 14.1749 21.9675 12.5209 20.7182 11.2737C19.4689 10.0266 17.8032 9.34217 16.0344 9.34217C12.3859 9.33837 9.41356 12.2927 9.41356 15.9277C9.41356 17.1711 9.76122 18.384 10.426 19.4334L10.5826 19.6844L9.91404 22.114L12.4202 21.46Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27893 23.7224L9.37158 19.7566C8.69536 18.5969 8.34006 17.2775 8.34006 15.9315C8.34388 11.711 11.7937 8.27753 16.0344 8.27753C18.0936 8.27753 20.023 9.07601 21.4747 10.5209C22.9265 11.9657 23.725 13.8897 23.725 15.9353C23.725 20.1559 20.2713 23.5893 16.0344 23.5893H16.0306C14.7431 23.5893 13.4785 23.2661 12.3553 22.6578L8.27893 23.7224Z",
    fill: "url(#paint1_linear_374_6791)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24L9.13085 19.8935C8.43171 18.6882 8.06495 17.3232 8.06877 15.9277C8.06877 11.5551 11.6447 7.99997 16.0344 7.99997C18.1662 7.99997 20.1681 8.82506 21.6695 10.3232C23.1748 11.8213 24.0038 13.8137 24 15.9315C24 20.3042 20.4241 23.8593 16.0306 23.8593H16.0267C14.6934 23.8593 13.383 23.5247 12.2178 22.8935L8 24ZM12.4202 21.46L12.6609 21.6045C13.6772 22.2053 14.8424 22.5209 16.0306 22.5247H16.0344C19.6829 22.5247 22.6552 19.5703 22.6552 15.9353C22.6552 14.1749 21.9675 12.5209 20.7182 11.2737C19.4689 10.0266 17.8032 9.34217 16.0344 9.34217C12.3859 9.33837 9.41356 12.2927 9.41356 15.9277C9.41356 17.1711 9.76122 18.384 10.426 19.4334L10.5826 19.6844L9.91404 22.114L12.4202 21.46Z",
    fill: "url(#paint2_linear_374_6791)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0439 12.6122C13.8949 12.2814 13.7382 12.2737 13.5969 12.2699C13.4823 12.2661 13.3485 12.2661 13.2148 12.2661C13.0811 12.2661 12.8672 12.3156 12.6838 12.5133C12.5004 12.711 11.9885 13.1901 11.9885 14.1673C11.9885 15.1407 12.7029 16.0836 12.8022 16.2167C12.9015 16.3498 14.1814 18.4144 16.2024 19.2091C17.8834 19.8707 18.2272 19.7376 18.5902 19.7034C18.9531 19.6692 19.7669 19.2243 19.935 18.7604C20.0992 18.2966 20.0992 17.9011 20.0496 17.8175C19.9999 17.7338 19.8662 17.6844 19.6675 17.5855C19.4689 17.4867 18.4908 17.0076 18.3075 16.9391C18.1241 16.8745 17.9904 16.8403 17.8605 17.038C17.7268 17.2357 17.3447 17.6806 17.2301 17.8137C17.1155 17.9468 16.9971 17.962 16.7984 17.8631C16.5997 17.7642 15.9579 17.5551 15.1976 16.8783C14.6055 16.3536 14.2043 15.7034 14.0897 15.5057C13.9751 15.308 14.0782 15.2015 14.1776 15.1026C14.2654 15.0152 14.3762 14.8707 14.4756 14.7566C14.5749 14.6426 14.6093 14.5589 14.6742 14.4258C14.7392 14.2928 14.7086 14.1787 14.6589 14.0798C14.6093 13.9848 14.2196 13.0038 14.0439 12.6122Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_6791",
    x1: 15.9992,
    y1: 31.9984,
    x2: 15.9992,
    y2: -0.0011196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_6791",
    x1: 16.0015,
    y1: 23.7216,
    x2: 16.0015,
    y2: 8.27699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_374_6791",
    x1: 16.0016,
    y1: 23.9985,
    x2: 16.0016,
    y2: 7.99997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappAtivo);
export default __webpack_public_path__ + "static/media/Whatsapp-Ativo.b18510f8.svg";
export { ForwardRef as ReactComponent };